'use strict';
require('../modules/es.parse-int');
var path = require('../internals/path');

module.exports = path.parseInt;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/parse-int.js
// module id = 586
// module chunks = 13